import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomNavigationService {

  constructor(private router: Router) {}

  navigate(commands: any[], extras: any = {}): void {
    extras.skipLocationChange = true;
    this.router.navigate(commands, extras);
  }

  navigateByUrl(url: string, extras: any = {}): void {
    extras.skipLocationChange = true;
    this.router.navigateByUrl(url, extras);
  }
}
